import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReferralPaid = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 16,
		height: 16,
		rx: 8,
		fill: "black"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4 8.28009L7.00039 11L12 5",
		stroke: "white",
		strokeWidth: 1.5
	})]
});
export default SvgReferralPaid;
